import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import { Navigate } from 'react-router-dom';
import moment from "moment";
import { ActionPlansContext } from "context/ActionPlansContext";
import ActionContext from "context/ActionContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import ImageList from "@mui/material/ImageList";
import { makeStyles } from "@mui/styles";
import UserService from "services/UserService";
import { getActionTURPE } from "services/ConfigServices";
import RTContracts from "./RTContracts";
import SubmitButton from "components/CustomButtons/SubmitButton";
import {
  calculateTurpeEco,
  optimizePsous,
  calculateFTAOptimization,
} from "utilities/fonctionsturpe.js";

function SelectContractsDialog(props) {
  const { closeModal, setLoading, refetch } = props;

  const appContext = useContext(ActionPlansContext);
  const { actionPlans, setActionPlans } = appContext;
  const actionContext = useContext(ActionContext);
  const { action, setAction } = actionContext;
  const [selectedContracts, setSelectedContracts] = useState();

  const handleSelectedChange = ({ selectedRows }) => {
    setSelectedContracts(selectedRows);
  };

  const handleSubmit = async () => {
    let meters = action.parameters?.impact?.meters;

    meters.map((m) => (m.details.newContract = selectedContracts[0].uuid));

    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters?.impact,
          meters,
          newContract: selectedContracts,
        },
      },
    }));
    closeModal();
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <RTContracts
            selectedContracts={selectedContracts}
            handleSelectedChange={handleSelectedChange}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <div style={{ display: "flex", flexDirection: "flex-end", marginTop: "10px"}}>
            <SubmitButton
              buttonDisabled={!selectedContracts? true : selectedContracts.length === 0}
              handleSubmit={handleSubmit}
            >
              Valider la sélection
            </SubmitButton>
          </div>
        </GridItem>
      </GridContainer>
    </>
  );
}

export default SelectContractsDialog;
